import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import api, { arr } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import EmptyState from "@/components/common/EmptyState";

export default function Notifications() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/notifications").then(({ data }) => setList(arr(data?.notifications))).catch(() => setList([]));
    api.put("/notifications/read-all").catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <PageHeader title="Notifications" subtitle="Alerts and updates for your business" icon={Bell} />
      {list.length === 0 ? (
        <EmptyState icon={Bell} title="No notifications" description="You're all caught up." />
      ) : (
        <div className="space-y-3">
          {list.map((n) => (
            <div key={n.id} className="card-surface flex items-start gap-3 p-4">
              <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-600"><Bell className="h-4 w-4" /></div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-slate-800">{n.title}</p>
                <p className="text-sm text-slate-500">{n.message}</p>
                <p className="mt-1 text-xs text-slate-400">{new Date(n.createdAt).toLocaleString()}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
